<template>
  <div id="profile">
    <div class="half-side" v-if="!token"></div>
    <template v-if="!token">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-md-offset-1">
            <div class="login">
              <h2 class="section-title">Sign in</h2>
              <div class="alert alert-warning" v-if="login.topError">
                <button type="button" aria-hidden="true" class="close">×</button>
                <span>{{ login.topError }}</span>
              </div>
              <form>
                <div :class="[login.email ? 'show-label' : '', 'form-group']">
                  <label>Email</label>
                  <input type="text" class="form-control" placeholder="Email" v-model="login.email" />
                  <h6 class="text-danger small" v-if="login.formError && typeof login.formError.email !== 'undefined'">{{ login.formError.email }}</h6>
                </div>
                <div :class="[login.password ? 'show-label' : '', 'form-group']">
                  <label>Password</label>
                  <input type="password" class="form-control" placeholder="Password" v-model="login.password" />
                  <h6 class="text-danger small" v-if="login.formError && typeof login.formError.password !== 'undefined'">{{ login.formError.password }}</h6>
                </div>
                <div class="form-group">
                  <b-button variant="primary" class="pull-left" @click="signin($event)">Login</b-button>
                  <router-link to="/restore-password" tag="button" class="btn btn-link pull-right">
                    Forgot Password?
                  </router-link>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-5">
            <div class="register">
              <h2 class="section-title">Register</h2>
              <div class="alert alert-warning" v-if="registration.topError">
                <button type="button" aria-hidden="true" class="close">×</button>
                <span>{{ registration.topError }}</span>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-6">
                    <div :class="[registration.firstName ? 'show-label' : '', 'form-group']">
                      <label>First Name</label>
                      <input type="text" class="form-control" placeholder="First Name" v-model="registration.firstName" />
                      <h6 class="text-danger small" v-if="registration.formError && typeof registration.formError.firstName !== 'undefined'">{{ registration.formError.firstName }}</h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div :class="[registration.lastName ? 'show-label' : '', 'form-group']">
                      <label>Last Name</label>
                      <input type="text" class="form-control" placeholder="Last Name" v-model="registration.lastName" />
                      <h6 class="text-danger small" v-if="registration.formError && typeof registration.formError.lastName !== 'undefined'">{{ registration.formError.lastName }}</h6>
                    </div>
                  </div>
                </div>
                <div :class="[registration.email ? 'show-label' : '', 'form-group']">
                  <label>Email</label>
                  <input type="text" class="form-control" placeholder="Email" v-model="registration.email" />
                  <h6 class="text-danger small" v-if="registration.formError && typeof registration.formError.email !== 'undefined'">{{ registration.formError.email }}</h6>
                </div>
                <div :class="[registration.password ? 'show-label' : '', 'form-group']">
                  <label>Password</label>
                  <input type="password" class="form-control" placeholder="Password" v-model="registration.password" />
                  <h6 class="text-danger small" v-if="registration.formError && typeof registration.formError.password !== 'undefined'">{{ registration.formError.password }}</h6>
                </div>
                <div :class="[registration.password_confirmation ? 'show-label' : '', 'form-group']">
                  <label>Confirm Password</label>
                  <input type="password" class="form-control" placeholder="Confirm Password" v-model="registration.password_confirmation" />
                  <h6 class="text-danger small" v-if="registration.formError && typeof registration.formError.password_confirmation !== 'undefined'">{{ registration.formError.password_confirmation }}</h6>
                </div>
                <div class="form-group not-hide-label">
                  <b-form-checkbox :class="[registration.termsAndCondition ? 'is-checked' : '']" id="termsAndConditions"
                                   v-model="registration.termsAndCondition" :value="true" :unchecked-value="false">
                    I agree with <a href="#" target="_blank">Terms</a> and <a href="#" target="_blank">Privacy</a>
                    of Kungfood.co.uk
                  </b-form-checkbox>
                </div>
                <div class="form-group">
                  <b-btn variant="primary" @click="register($event)">Register</b-btn>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="token">
      <div class="my-profile">
        <div class="top">
          <div class="container">
            <div class="pull-left">
              <h2>{{ user.first_name }} {{ user.last_name }}</h2>
              <h5>Kungfood member since {{ user.created_at }}</h5>
            </div>
            <div class="pull-right">
              <b-btn variant="danger" class="logout-btn" @click="logout($event)">Logout</b-btn>
            </div>
          </div>
        </div>
        <br>
        <div class="bottom">
          <div class="container">
            <b-tabs>
              <b-tab title="My Details" active>
                <br>
                <MyDetails></MyDetails>
              </b-tab>
              <b-tab title="My Orders">
                <br>
                <MyOrders></MyOrders>
              </b-tab>
              <b-tab title="My Payment Sources">
                <br>
                <MyPaymentSources></MyPaymentSources>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import MyDetails from './my-details.vue'
  import MyOrders from './my-orders.vue'
  import MyPaymentSources from './my-payment-sources.vue'

  export default {
    name: 'profile',
    data () {
      return {
        login: {
          email: '',
          password: '',
          topError: null,
          formError: null
        },
        registration: {
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          password_confirmation: '',
          termsAndCondition: false,
          topError: null,
          formError: null
        }
      }
    },
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user
      })
    },
    methods: {
      signin (e) {
        e.preventDefault()

        this.login.topError = null
        this.login.formError = null
        this.registration.topError = null
        this.registration.formError = null

        this.$store.dispatch('LoadingOn')
        this.$store.dispatch('Signin', {
          email: this.login.email,
          password: this.login.password
        })
          .then(() => {
            let kf = this
            setTimeout(function () {
              kf.$store.dispatch('LoadingOff')
            }, 1000)
            kf.$router.push({ name: 'profile' })
          })
          .catch((error) => {
            this.$store.dispatch('LoadingOff')
            this.login.formError = {
              'email': error.errors.email ? error.errors.email.join(' ') : null,
              'password': error.errors.password ? error.errors.password.join(' ') : null
            }

            if (error.errors.top_error) {
              this.login.topError = error.errors.top_error
            }
          })
      },
      register (e) {
        e.preventDefault()

        this.login.topError = null
        this.login.formError = null
        this.registration.topError = null
        this.registration.formError = null

        if (this.registration.password !== this.registration.password_confirmation) {
          this.registration.formError = {
            'password_confirmation': 'The passwords do not match.'
          }

          this.registration.password_confirmation = ''
        } else if (!this.registration.termsAndCondition) {
          this.registration.topError = 'You should agree with our Terms and Privacy Policy.'
        } else {
          this.$store.dispatch('LoadingOn')
          this.$store.dispatch('Register', {
            first_name: this.registration.firstName,
            last_name: this.registration.lastName,
            email: this.registration.email,
            password: this.registration.password,
            password_confirmation: this.registration.password_confirmation
          })
            .then(() => {
              let kf = this

              setTimeout(function () {
                kf.$store.dispatch('LoadingOff')
              }, 1000)

              window.location.href = '/profile'
            })
            .catch((error) => {
              this.$store.dispatch('LoadingOff')
              this.registration.formError = {
                'firstName': error.errors.first_name ? error.errors.first_name.join(' ') : null,
                'lastName': error.errors.first_name ? error.errors.last_name.join(' ') : null,
                'email': error.errors.email ? error.errors.email.join(' ') : null,
                'password': error.errors.password ? error.errors.password.join(' ') : null
              }

              if (error.errors.top_error) {
                this.registration.topError = error.errors.top_error
              }
            })
        }
      },
      logout (e) {
        e.preventDefault()

        if (confirm('Are you sure you want to logout?')) {
          this.$store.dispatch('AuthSignout')
          this.$store.dispatch('LoadingOn')

          let kf = this

          kf.$router.push({ name: 'homepage' })
          setTimeout(function () {
            kf.$store.dispatch('LoadingOff')
          }, 1000)
        }
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    components: {
      MyDetails,
      MyOrders,
      MyPaymentSources
    }
  }

</script>



// WEBPACK FOOTER //
// profile.vue?22054de4